export default "__VITE_ASSET__f2ddf58f__"